import { DomStorageUtils } from '../utils/DomStorageUtils';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DomStorageDisabledGuard implements CanActivate {

  constructor(private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    const localStorageSupported = DomStorageUtils.localStorageSupported();

    if (state.url === '/dom-storage-disabled' && localStorageSupported) {
      return this.router.createUrlTree(['/']);
    }
    else if(state.url !== '/dom-storage-disabled' && !localStorageSupported) {
      return this.router.createUrlTree(['/dom-storage-disabled']);
    }

    return true;
  }

}
